import { useMemo } from 'react';
import randomKey from '../node_modules/@arcadiapower/warbler/dist/number/random-key.js';

const useId = (prefix = 'component', propId) => {
    return useMemo(() => propId || `${prefix}-${randomKey(15)}`, [prefix, propId]);
};

export { useId as default };
